import ScanBarCode from '../ScanBarCode'
import DateForm from './DateForm'
import InputForm from './InputForm'
import SelectForm from './SelectForm'
import SelectSearch from './SelectSearch'

interface FieldObject {
  type: string
  flow: string
  label: string
  inputName: string
  inputMode: string
  defaultValue?: string
  disabled?: boolean
  hidden?: boolean
  min?: number
  max?: number
  options?: any[]
  placeholder?: string
  note?: string
  largeNote?: boolean
  imageText?: string
  imageSrc?: string
  optional?: boolean
  minLimitDate?: string
  maxLimitDate?: string
  defaultDate?: string
  shortInput?: boolean
  setSelected?: (param: string) => {}
  searchInput?: boolean
  searchFunction?: (param: string) => {}
  clearFunction?: () => {}
}

interface Props {
  fields: FieldObject[] | any
  storeForm: string
  inputsPosition: 'stacked' | 'fixed' | 'floating' | undefined
}

const Form = ({ fields, inputsPosition, storeForm }: Props) => {
  const shortInputs: any = fields.filter((field: any) => field?.shortInput)
  return (
    <form className="genericForm">
      {fields.map((field: any) => {
        if (!field?.shortInput && (field?.type === 'text' || field?.type === 'number' || field?.type === 'tel'))
          return (
            <InputForm
              key={`input-${field.label}`}
              label={field.label}
              inputName={field.inputName}
              inputMode={field.inputMode}
              minChar={field?.min}
              maxChar={field?.max}
              placeholder={field.placeholder}
              note={field.note}
              storeForm={storeForm}
              inputsPosition={inputsPosition}
              disabled={field.disabled}
              hidden={field.hidden}
              imageText={field.imageText}
              imageSrc={field.imageSrc}
              largeNote={field.largeNote}
              optional={field.optional}
              searchInput={field.searchInput}
              searchFunction={field.searchFunction}
              clearFunction={field.clearFunction}
            />
          )
        else if (field?.type === 'select')
          return (
            <SelectForm
              key={`select-${field.label}`}
              label={field.label}
              inputName={field.inputName}
              options={field.options}
              placeholder={field.placeholder}
              storeForm={storeForm}
              defaultValue={field.defaultValue}
              inputsPosition={inputsPosition}
              disabled={field.disabled}
              hidden={field.hidden}
              setSelected={field.setSelected}
            />
          )
        else if (field?.type === 'selectSearch')
          return (
            <SelectSearch
              key={`selectSearch-${field.label}`}
              label={field.label}
              inputName={field.inputName}
              options={field.options}
              placeholder={field.placeholder}
              storeForm={storeForm}
              inputsPosition={inputsPosition}
              disabled={field.disabled}
              hidden={field.hidden}
              setSelected={field.setSelected}
            />
          )
        else if (field?.type === 'date')
          return (
            <DateForm
              key={`date-${field.label}`}
              flow={field.flow}
              label={field.label}
              inputName={field.inputName}
              note={field.note}
              storeForm={storeForm}
              minLimitDate={field.minLimitDate}
              maxLimitDate={field.maxLimitDate}
              defaultDate={field.defaultDate}
              disabled={field.disabled}
            />
          )
        else if (field?.type === 'scanBarCodeComponent')
          return (
            <ScanBarCode
              key={`scanBarCode-${field.label}`}
              label={field.label}
              inputToFill={field.inputName}
              storeForm={storeForm}
            />
          )
        else return null
      })}
      <div className="shortInput-container">
        {shortInputs.length === 2 &&
          fields.map((field: any) => {
            return (
              field.shortInput && (
                <InputForm
                  key={`input-${field.label}`}
                  label={field.label}
                  inputName={field.inputName}
                  inputMode={field.inputMode}
                  minChar={field?.min}
                  maxChar={field?.max}
                  placeholder={field.placeholder}
                  note={field.note}
                  storeForm={storeForm}
                  inputsPosition={inputsPosition}
                  disabled={field.disabled}
                  hidden={field.hidden}
                  imageText={field.imageText}
                  imageSrc={field.imageSrc}
                  largeNote={field.largeNote}
                  optional={field.optional}
                />
              )
            )
          })}
      </div>
    </form>
  )
}

export default Form
